export function shouldShowOfflineWorkoutState(
  online: boolean,
  reconciliationRequired: boolean,
  syncFailed = false,
): boolean {
  return !online || reconciliationRequired || syncFailed
}

export function isWorkoutCompletionPending(status: string, pendingOfflineActions: number): boolean {
  return status === 'Completed' && pendingOfflineActions > 0
}
